<template>
  <SmallPlatesBody />
</template>

<script>
import SmallPlatesBody from '../molecules/SmallPlatesBody.vue'


export default {
  name: 'SmallPlatesView',
  components: {
    SmallPlatesBody,
  }
}
</script>
